var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vxe-table",
    { attrs: { data: _vm.tableData } },
    [
      _c("vxe-table-column", {
        attrs: { field: "signatory", title: "签署方" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [_c("span", [_vm._v(_vm._s(_vm.atoryName(row)))])]
            },
          },
        ]),
      }),
      _c("vxe-table-column", {
        attrs: { field: "signatoryName", title: "签署方名称" },
      }),
      _c("vxe-table-column", {
        attrs: { field: "signatoryCode", title: "客户编码" },
      }),
      _c("vxe-table-column", {
        attrs: { field: "signDate", title: "签署时间" },
      }),
      _c("vxe-table-column", {
        attrs: { field: "signAccount", title: "签署人" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }